import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import OperationsProjectService from '../Services/OperationsProjectService';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LongText from '../Elements/LongText';
import dateTimeHelper from '../Helpers/datetimeHelper';

class SystemAlertItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.AlertId = '';
      this.Title = '';
      this.Message = '';
      this.LinkUrl = '';
      this.SeverityLevel = '1';
      this.IsActive = true;
      this.DisplayOrder = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.StartAt = dateTimeHelper.UTCYYYYsMMsDDsHHsMM(); // Default: Now in UTC
      this.AutoDeletionAfterExpiration = true;
      this.IsDismissible = '';
      this.LengthHours = '24';
      this.PopupDateTime = dateTimeHelper.UTCYYYYsMMsDDsHHsMM(); // Default: Now in UTC

      return;
    }

    this.AlertId = item.alertId;
    this.Title = item.title;
    this.Message = item.message;
    this.LinkUrl = item.linkUrl;
    this.SeverityLevel = item.severityLevel;
    this.IsActive = item.isActive;
    this.DisplayOrder = item.displayOrder;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.StartAt = dateTimeHelper.toYYYYsMMsDDsHHsMM(item.startAt, "-");
    this.EndAtComputed = dateTimeHelper.toYYYYsMMsDDsHHsMM(item.endAtComputed, "-");
    this.AutoDeletionAfterExpiration = item.autoDeletionAfterExpiration;
    this.IsDismissible = item.isDismissible;
    this.LengthHours = item.lengthHours;
    this.PopupDateTime = dateTimeHelper.toYYYYsMMsDDsHHsMM(item.popupDateTime, "-");
  }

  static NameOfTheIdField ()
  {
    return 'AlertId';
  }
  static nameOfTheItemDetailList (item)
  {
    if (item) return <span>Alert Details - {item.AlertId}</span>;
    return 'Alert Details';
  }

  static FieldsToShowInDataTable ()
  {
    return [
      {
        label: 'Alert ID',
        orderById: 'AlertId',
        data: 'AlertId',
        // type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Title',
        orderById: 'Title',
        data: 'Title',
      },
      {
        label: 'Message',
        orderById: 'Message',
        data: SystemAlertItem.getMessageCellContent,
      },
      {
        label: 'Severity',
        orderById: 'SeverityLevel',
        data: SystemAlertItem.getSeverityLevelContent,
      },
      {
        label: 'Order',
        orderById: 'DisplayOrder',
        data: 'DisplayOrder',
      },
      {
        label: 'Active?',
        orderById: 'IsActive',
        data: 'IsActive',
        type: FieldTypesEnum.YesNo,
      },
      {
        label: 'Start',
        orderById: 'StartAt',
        data: 'StartAt',
      },
      {
        label: 'End',
        orderById: 'EndAtComputed',
        data: 'EndAtComputed',
      },
      {
        label: 'Popup DateTime',
        orderById: 'PopupDateTime',
        data: 'PopupDateTime',
      },
      {
        label: ' ',
        orderById: 'Actions',
        data: SystemAlertItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getMessageCellContent (item)
  {
    return (
      <LongText
        text={item.Message ? item.Message : ' '}
        maxLength={40}
      />
    );
  }


  static getSeverityLevelContent (item)
  {
    switch (item.SeverityLevel)
    {
      case 3:
        return <span className="badge bg-info text-dark">Info (3)</span>;
      case 2:
        return <span className="badge bg-warning text-dark">Warning (2)</span>;
      case 1:
        return <span className="badge bg-danger text-white">Critical (1)</span>;
      default:
        return <span>{item.SeverityLevel}</span>;
    }
  }

  static getActionsContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => SystemAlertItem.editFunction(item.AlertId, item),
          },
        ]}
      />
    );
  }

  static editFunction = (id, item) =>
  {
    alert('Empty function');
  };

  static deleteFunction = (id, item) =>
  {
    alert('Empty function');
  };

  static DateFields = [ 'StartAt', 'EndAtComputed', 'CreatedOn', 'ModifiedOn' ];

  static MoneyFields = [];

  static MoneyFieldsSecondary = [];

  static BoolFields = [ 'IsActive', 'AutoDeletionAfterExpiration', 'IsDismissible' ];

  static serviceFunctionForListTable = (item) => OperationsProjectService.GetProjectById(item.AlertId);

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [ { name: 'AlertId', label: 'Alert ID' } ],
    },
  ];

  static Currency ()
  {
    return '';
  }
  static CurrencySecondary ()
  {
    return '';
  }
}

export default SystemAlertItem;
